export default "__VITE_ASSET__nh2cc09o__"